import { render, staticRenderFns } from "./InvoiceInfo.vue?vue&type=template&id=20d1ccec&scoped=true"
import script from "./InvoiceInfo.vue?vue&type=script&lang=js"
export * from "./InvoiceInfo.vue?vue&type=script&lang=js"
import style0 from "./InvoiceInfo.vue?vue&type=style&index=0&id=20d1ccec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d1ccec",
  null
  
)

export default component.exports